// input
import IconEyeClose from './input/icon-eye-close.svg';
import IconEyeOpen from './input/icon-eye-open.svg';
import IconCheckbox from './input/icon-checkbox.svg';

// license-list
import DeleteImg from './license-list/delete-img.png';

// logo
import Logo from './logo/logo.png';
import AdminLogo from './logo/admin-logo.png';
import PingPongLogo from './logo/pingpong-logo.png';

// navbar
import LogoutImg from './navbar/logout.svg';

// partner-list
import DownloadIcon from './partner-list/download-icon.png';

// player-list
import DownArrowImg from './player-list/down-arrow.png';
import NoneDataImg from './player-list/none-data.png';

export const Images = {
  // input
  IconEyeClose,
  IconEyeOpen,
  IconCheckbox,
  // license-list
  DeleteImg,
  // logo
  Logo,
  AdminLogo,
  PingPongLogo,
  // navbar
  LogoutImg,
  // partner-list
  DownloadIcon,
  // player-list
  DownArrowImg,
  NoneDataImg,
};
